module.exports = __webpack_public_path__ + "img/LC.39f8eb25.png";